import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Stack, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

export default function Modal({title, children, open, onClose, noActions, text}){
    
    return <Dialog open={open} onClose={onClose}>

        <DialogTitle>
            
            <Stack direction='row' justifyContent='space-between' alignItems='center'>

                <Typography variant='h4'>{title || 'Informations'}</Typography>

                <IconButton size='small' onClick={onClose}>
                    <CloseIcon />
                </IconButton>
                
            </Stack>
            
        </DialogTitle>

        <DialogContent>

            <DialogContentText>
                {text}
            </DialogContentText>

            {children}

            {!noActions && 
                <DialogActions>

                    <Button 
                        variant='contained' 
                        onClick={onClose}
                        autoFocus
                    >
                        OK
                    </Button>

                </DialogActions>
            }

        </DialogContent>

    </Dialog>


}